import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"

export default Viewer